/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Button, Image, Row, Col, Container } from 'react-bootstrap';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { ChevronRightIcon } from '@heroicons/react/solid';
import { LeftArrow, RightArrow } from './arrows';

import './styles.css';

import * as S from './styles';

export interface IBadgeCarouselItem {
  key: string;
  titleImage: string;
  title: string;
  subtitleIcon?: string;
  subtitle?: string;
  [key: string]: any;
}

export interface IBadgeCarouselProps {
  carouselItems?: IBadgeCarouselItem[];
  onCarouselImageClick?(item?: IBadgeCarouselItem): void;
  carouselStyles: {
    width: string;
    height: string;
  };
}

function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
}

export const BadgeCarousel = ({
  carouselItems,
  carouselStyles,
  onCarouselImageClick,
}: IBadgeCarouselProps) => {
  const _renderType = (item: ICarouselItem, index: number) => {
    if (item) {
      return (
        <Row
          className="justify-content-md-center"
          style={{ cursor: 'pointer' }}
          onClick={onCarouselImageClick.bind(null, item)}
        >
          {item?.titleImage && (
            <Col xs={12} sm={12} md={12}>
              <Image
                src={item.titleImage}
                className="avatar d-block mx-auto img-fluid w-50"
                style={{
                  objectFit: 'contain',
                  height: '50px',
                  width: '50px',
                  alignSelf: 'center',
                }}
              />
            </Col>
          )}
          <Col>
            <p style={{ fontWeight: 'bold', textAlign: 'center' }}>
              {item?.title ?? ''}
            </p>
          </Col>
        </Row>
        // <Button  variant="outline-gray-900" className="m-1 pt-2 pb-2" onClick={onCarouselImageClick?.bind(null, item)} style={{ borderRadius: "40px", maxWidth: '320px', height: '80px' }}>
        //
        //   <span style={{ fontWeight: 'bold' }}>
        //     {item?.title ?? ""}
        //   </span>
        //   <ChevronRightIcon className="icon icon-xs ms-1" />
        // </Button>
      );
    }
  };

  return (
    <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} onWheel={onWheel}>
      {carouselItems?.map((item, index) => (
        <div
          key={`badge-carousel-item-${index}`}
          style={S.CarouselItemContainer}
        >
          {_renderType(item, index)}
        </div>
      ))}
    </ScrollMenu>
  );
};

BadgeCarousel.defaultProps = {
  carouselItems: [],
  carouselStyles: {},
};
